import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import styles from './styles.module.css';
import baseStyles from '../../styles.module.css';

type Props = {
  value?: string;
  onChange?: (v?: string) => void;
};

export function WisoryPhoneInput({ value, onChange }: Props) {
  return (
    <PhoneInput
      inputClass={baseStyles.baseWrapper}
      containerClass={styles.phoneWrapper}
      country="se"
      value={value}
      masks={{ se: '... ... ...' }}
      onFocus={() => {
        document.querySelector('.flag-dropdown')?.classList.add(styles.dropdownFocus);
      }}
      onBlur={() => {
        document.querySelector('.flag-dropdown')?.classList.remove(styles.dropdownFocus);
      }}
      onChange={(phone) => {
        if (phone) {
          onChange?.(`+${phone}`);
        } else {
          onChange?.(undefined);
        }
      }}
    />
  );
}
